module.exports = __webpack_public_path__ + "static/media/ellipsis-grey.fb943ecc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/img/ellipsis-grey.svg
// module id = 300
// module chunks = 0